import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import { SectionDivider } from '../../shared';

Builder.registerComponent(SectionDivider, {
  name: BUILDER_DIVIDER_NAMES.SectionDivider,
});